var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #bcceff;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.19,
    cy: 100,
    r: 62.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m25.63,67.57l44.55,86.88,44.55-86.88H25.63Zm30.13,44.72l-6.85-13.35h6.85v13.35Zm11.06,21.57l-7.86-15.32v-19.6h7.86v34.92Zm14.58-15.32l-7.86,15.32v-34.92h7.86v19.6Zm3.2-6.24v-13.36h6.85l-6.85,13.36Zm-44.97-31.46l-3.52-6.87h68.14l-3.52,6.87c-3.68,7.18-11.07,11.69-19.14,11.69h-22.82c-8.07,0-15.46-4.51-19.14-11.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.82,
    y: 80.67,
    width: 6.74,
    height: 6.74
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.53,53.92h12.72l-17.5,49.34h-15.04l-17.5-49.34h12.79l12.23,37.25,12.3-37.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.12,53.5c0-3.65,2.88-6.54,7.17-6.54s7.1,2.88,7.1,6.54-2.88,6.47-7.1,6.47-7.17-2.88-7.17-6.47Zm1.12,10.54h12.02v39.22h-12.02v-39.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.87,74.02h-4.78v-9.98h4.78v-9.56h12.02v9.56h7.87v9.98h-7.87v15.74c0,2.32.98,3.3,3.65,3.3h4.29v10.19h-6.12c-8.15,0-13.85-3.44-13.85-13.64v-15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m254.4,74.02h-4.78v-9.98h4.78v-9.56h12.02v9.56h7.87v9.98h-7.87v15.74c0,2.32.98,3.3,3.65,3.3h4.29v10.19h-6.12c-8.15,0-13.85-3.44-13.85-13.64v-15.6Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m161.59,116.56h13.47v2.53h-10.36v8.04h8.41v2.53h-8.41v10.74h-3.11v-23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m178.31,116.49c0-1.2.92-2.12,2.12-2.12,1.13,0,2.05.92,2.05,2.12s-.92,2.12-2.05,2.12c-1.2,0-2.12-.92-2.12-2.12Zm.51,5.16h3.11v18.74h-3.11v-18.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m200.94,129.8c0-3.83-2.09-5.78-5.23-5.78s-5.37,1.98-5.37,6.02v10.36h-3.11v-18.74h3.11v2.67c1.23-1.95,3.49-3.01,6.02-3.01,4.34,0,7.66,2.67,7.66,8.04v11.05h-3.08v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m216.84,121.35c3.49,0,5.88,1.78,6.98,3.73v-3.42h3.15v18.74h-3.15v-3.49c-1.13,2.02-3.56,3.8-7.01,3.8-4.99,0-8.86-3.93-8.86-9.75s3.86-9.61,8.89-9.61Zm.62,2.7c-3.42,0-6.33,2.5-6.33,6.91s2.91,7.01,6.33,7.01,6.36-2.56,6.36-6.98-2.94-6.94-6.36-6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m245.94,129.8c0-3.83-2.09-5.78-5.23-5.78s-5.37,1.98-5.37,6.02v10.36h-3.11v-18.74h3.11v2.67c1.23-1.95,3.49-3.01,6.02-3.01,4.34,0,7.66,2.67,7.66,8.04v11.05h-3.08v-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m262.08,121.35c4.65,0,7.69,2.39,8.65,6.33h-3.35c-.65-2.26-2.53-3.69-5.3-3.69-3.42,0-5.95,2.43-5.95,7.01s2.53,7.08,5.95,7.08c2.77,0,4.62-1.33,5.3-3.69h3.35c-.96,3.73-4,6.33-8.65,6.33-5.34,0-9.13-3.76-9.13-9.71s3.8-9.64,9.13-9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m282.97,140.71c-5.33,0-9.27-3.76-9.27-9.71s3.8-9.64,9.27-9.64,8.99,3.83,8.99,8.96c0,.68-.03,1.23-.1,1.88h-14.98c.24,3.8,2.91,5.88,6.09,5.88,2.8,0,4.58-1.44,5.27-3.45h3.35c-.96,3.42-3.97,6.09-8.62,6.09Zm-6.05-11.05h11.83c.03-3.66-2.7-5.68-5.92-5.68-3.04,0-5.57,2.02-5.92,5.68Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc866500.svg";
export { ForwardRef as ReactComponent };